import React, { useEffect, useRef, useState } from 'react';
import Wrapper from './Wrapper';
import {
  getCurrentPage,
  requestsSelector,
  setHasCustomizableParts,
  setNextButtonEnabled,
  setRequestData,
  setShowImagesPage,
  setSubmitButtonTitle,
  updateRequestPages,
} from '../../../redux/slicers/requestSlicer';
import { useDispatch, useSelector } from 'react-redux';
import Tips from '../../../components/Request/Tips';
import { Form } from 'react-bootstrap';
import styles from './Parts.module.scss';
import RequestThumbnailCardUI from './RequestThumbnailCardUI';
import cx from 'classnames';
import { errorToast } from '../../../helpers/toastHelper';
import icons from '../../../assets';
import {
  apiGetRequestFiles,
  apiGetRequestImages,
  apiGetRequestParts,
  apiDeleteRequestParts,
  apiUploadRequestFiles,
  apiUploadRequestParts,
} from '../../../helpers/api';
import { checkIfImage } from './helper';
import { ModalArea } from '../../../common/ModalButtonArea';
import ImageSlider from './ImageSlider';

import PartsTipImage from '../../../assets/images/requests/Parts.png';

function Parts({ className, isReadOnly }) {
  const _requestSelector = useSelector(requestsSelector);
  const [show, setShow] = useState(false);
  const [checked, setChecked] = useState(_requestSelector.hasCustomizableparts ? 1 : 2);
  const [selected, setSelected] = useState([]);
  const [parts, setParts] = useState([]);
  const [showParts, setShowParts] = useState([]);
  const [images, setimages] = useState([]);
  const [updatePartPosition, setUpdatePartPosition] = useState();

  const dispatch = useDispatch();
  const { RequestDeleteIcon } = icons;
  const dataRef = useRef({});

  const handleClick = ({ id }) => {
    if (selected.length === 3 && !selected.find((item) => item.id === id)) {
      errorToast('You can only select three images.');
      return;
    }

    const _selected = selected.find((item) => item.id === id)
      ? selected.filter((item) => item.id !== id)
      : [...selected, images.find((item) => item.id === id)];
    setSelected(_selected);
  };

  const handleDeleteClick = async (_id) => {
    const formData = new FormData();
    formData.append('delete_notes', true);
    const response = await apiDeleteRequestParts(_id, formData);
    if (response.status) {
      setParts(parts.filter((item) => item.currentImageId !== _id));
      dispatch(parts.filter((item) => item.currentImageId !== _id));
    }
  };

  const handleImageLoad = (_id) => setShowParts([...showParts, _id]);

  const handleSelectOtherImages = () => {
    dispatch(setShowImagesPage(true));
    dispatch(setNextButtonEnabled(true));
    dispatch(setSubmitButtonTitle('Go with selected images'));
    dispatch(setRequestData({ images: selected, subPages: [{ id: 5, isModal: true }], parts }));
  };

  useEffect(async () => {
    const partsResponse = await apiGetRequestParts(
      `?three_d_model_request=${_requestSelector.currentRequestId}&sort=id`
    );

    const _partsImageId = [];
    let _parts;

    if (partsResponse?.results?.length) {
      _parts = partsResponse?.results?.map((_item) => {
        if (_item.json_data) {
          _partsImageId.push(_item?.json_data?.currentImageId);
          return { ..._item.json_data, actual_id: _item.id, note: _item.note };
        } else return _item;
      });
    } else _parts = [];
    // else {
    //   _parts = currentPage?.data?.parts;
    //   _parts?.forEach((_part) => _partsImageId.push(_part?.currentImageId));
    // }

    setParts(_parts);

    const response = await apiGetRequestImages(
      `three_d_model_request=${_requestSelector.currentRequestId}&sort=id`
    );

    const _images = response.results
      ?.filter((img) => img?.file && checkIfImage(img?.file))
      ?.map((_image) => ({ id: _image.id, thumbnail: _image.file }));

    setimages(_images);
    setSelected(_images.filter((_item) => _partsImageId.includes(_item.id)));
  }, []);

  useEffect(() => {
    dispatch(setRequestData(''));
    window.addEventListener('resize', () => setUpdatePartPosition(!updatePartPosition));

    if (isReadOnly) return;

    return async () => {
      window.removeEventListener('resize', () => setUpdatePartPosition(!updatePartPosition));
      dispatch(setSubmitButtonTitle('Next'));
    };
  }, []);

  useEffect(() => {
    // dataRef.current['images'] = selected;
    // dataRef.current['parts'] = parts;
    dispatch(setNextButtonEnabled(true));

    if (checked === 2) {
      dispatch(setRequestData({ images: selected, parts }));
      //   dispatch(setNextButtonEnabled(true));
      return;
    }

    if (!selected.length) {
      dispatch(setSubmitButtonTitle('Next'));
      dispatch(setRequestData({ images: selected, parts }));
      return;
    }

    if (!parts?.length) {
      dispatch(setRequestData({ images: selected, subPages: [{ id: 5, isModal: true }], parts }));
      dispatch(setSubmitButtonTitle('Go with selected images'));
    } else {
      if (_requestSelector.showImagesPage) {
        dispatch(setRequestData({ images: selected, subPages: [{ id: 5, isModal: true }], parts }));
        dispatch(setSubmitButtonTitle('Go with selected images'));
      } else {
        dispatch(setRequestData({ images: selected, parts }));
        dispatch(setSubmitButtonTitle('Next'));
      }
    }
    // if (parts?.length && parts?.length <= 2) {
    //   dispatch(setNextButtonEnabled(false));
    // } else if (selected?.length) {
    //   dispatch(setNextButtonEnabled(true));
    // } else dispatch(setNextButtonEnabled(false));

    // if (_requestSelector.showImagesPage) {
    //   dispatch(setNextButtonEnabled(true));
    // }
  }, [selected, parts, checked]);

  const TIP_TEXT =
    'You have the option to individually select parts for customization. \n\nFor instance, you can choose different materials or colors for elements like piping, nail heads, and stitching, making them editable, customizable, or even removable.'


  return (
    <>
      <Wrapper
        title={!isReadOnly && `Mark different parts of ${_requestSelector.requestName}`}
        className={cx(className, isReadOnly && 'bg-white pb-0')}
        isReadOnly={isReadOnly}>
        {!isReadOnly && (
          <div>
            <h6>Is this product’s part made from different material ?</h6>{' '}
            <span className="text-muted">
              Normally a product is made from different materials like wood, metal, fabric, etc.
            </span>
            <Form className={styles.formWrapper}>
              <Form.Check type="radio" id="1" className={styles.formCheck}>
                <Form.Check.Input
                  type="radio"
                  name="type-group-2"
                  onClick={() => {
                    dispatch(setHasCustomizableParts(true));
                    setChecked(1);
                    dispatch(setSubmitButtonTitle('Go with selected images'));
                  }}
                  checked={checked === 1}
                />
                <Form.Label>
                  <span>Yes</span>
                </Form.Label>
              </Form.Check>
              <Form.Check type="radio" id="2" className={styles.formCheck}>
                <Form.Check.Input
                  type="radio"
                  name="type-group-2"
                  onClick={() => {
                    dispatch(setHasCustomizableParts(false));
                    setChecked(2);
                    dispatch(setSubmitButtonTitle('Next'));
                  }}
                  checked={checked === 2}
                />
                <Form.Label>
                  <span>No</span>
                </Form.Label>
              </Form.Check>
            </Form>
          </div>
        )}

        {checked === 1 ? (
          <>
            <div className="d-flex  gap-5">
              {(!parts?.length && !isReadOnly) ||
              (_requestSelector.showImagesPage && !isReadOnly) ? (
                <div className="w-75 py-3">
                  <h6>
                    Please select image to mark parts, in which you want different material finish.
                  </h6>{' '}
                  <span className="text-muted">
                    If all parts are not visible in 1 image, you can select multiple images. You can
                    select max 3 images
                  </span>
                  <RequestThumbnailCardUI
                    list={images}
                    selected={selected?.map((item) => item?.id)}
                    onCardClick={handleClick}
                    showSelectedText
                    noDataText="No images found"
                  />
                </div>
              ) : (
                <div className={cx('d-flex flex-column gap-3 pb-3', isReadOnly ? 'w-100' : 'w-75')}>
                  {selected.map((item) => {
                    return parts.filter((_item) => _item.currentImageId === item.id).length ? (
                      <div className={cx('p-3 ', styles.partsWrapper)}>
                        {!isReadOnly && (
                          <div
                            className={styles.deleteIcon}
                            onClick={() => handleDeleteClick(item.id)}>
                            <span>delete</span>
                            <RequestDeleteIcon />
                          </div>
                        )}
                        <div className="d-flex justify-content-between gap-3 h-100 p-3 pb-5">
                          <div className=" w-100">
                            <div
                              className="d-flex justify-content-around mx-auto position-relative h-100"
                              style={{ width: 'fit-content' }}>
                              <img
                                src={item.thumbnail}
                                className={cx('h-100 w-100')}
                                id={`_IMAGE_${item.id}_`}
                                onLoad={() => handleImageLoad(item.id)}
                                onClick={() => isReadOnly && setShow(item)}
                                style={
                                  isReadOnly ? { cursor: 'pointer', pointerEvents: 'all' } : {}
                                }
                              />
                              {showParts.includes(item.id) &&
                                parts.map(
                                  (part) =>
                                    part.currentImageId === item.id && (
                                      <div
                                        style={{
                                          left:
                                            (document.getElementById(`_IMAGE_${item.id}_`)
                                              ?.clientWidth /
                                              part.screenX) *
                                            (part.x - 25),
                                          top:
                                            (document.getElementById(`_IMAGE_${item.id}_`)
                                              ?.clientHeight /
                                              part.screenY) *
                                            (part.y - 35),
                                        }}
                                        className={cx(styles.partOnImage, updatePartPosition)}>
                                        <div className={styles.partCount}>{part.id}</div>
                                      </div>
                                    )
                                )}
                            </div>
                          </div>
                          <div
                            className="d-flex flex-column gap-4 px-5 "
                            style={{ width: '400px', overflowY: 'auto' }}>
                            {parts.map(
                              (_item) =>
                                _item.currentImageId === item.id && (
                                  <div
                                    className={cx(
                                      'd-flex gap-3 align-items-center',
                                      styles.noteDialog
                                    )}>
                                    <span className={styles.index}>{_item.id}</span>
                                    <span className={styles.title}>{_item.value}</span>
                                    {_item.note ? (
                                      <div className={styles.infoDialog}>
                                        <span
                                          dangerouslySetInnerHTML={{
                                            __html: _item.note.replace(/\r\n/g, '<br>'),
                                          }}
                                        />
                                      </div>
                                    ) : null}
                                  </div>
                                )
                            )}
                          </div>
                        </div>
                      </div>
                    ) : (
                      <></>
                    );
                  })}
                </div>
              )}
              {!isReadOnly && checked === 1 ? (
                <Tips
                  title="How to ?"
                  text={TIP_TEXT}
                  marginTop={!parts?.length ? 5.2 : 0}
                  showImages={false}
                  customImages={[PartsTipImage]}
                />
              ) : null}
            </div>

            {!isReadOnly && parts?.length && !_requestSelector.showImagesPage ? (
              <div
                className="pb-5 ps-3 w-75"
                style={{ fontWeight: '500' }}
                onClick={handleSelectOtherImages}>
                <span style={{ color: 'var(--primary-color)', float: 'right' }}>
                  Edit parts or Select other images
                </span>
              </div>
            ) : null}
          </>
        ) : null}

        {isReadOnly && (!parts?.length || !_requestSelector.hasCustomizableparts) ? (
          <div className="pb-3 ps-3" style={{ fontWeight: '500' }}>
            <span style={{ color: 'var(--primary-color)' }}>No</span> :- Parts selected.
          </div>
        ) : null}
      </Wrapper>

      {isReadOnly ? (
        <ModalArea
          showModal={!!show}
          setShowModal={() => setShow(false)}
          className={cx('view-parts', styles.viewParts)}
          title={''}
          subtitle={''}
          size="lg"
          modalClassName="view-parts-info"
          centered={true}
          backdrop={true}
          body={<ImageSlider images={[show] || []} parts={parts} isReadOnly />}
        />
      ) : null}
    </>
  );
}

export default Parts;
